const P = ["#f5dedf", "#eb94ad", "#ce5194", "#530c56"], f = ["#f5dedf", "#f0b7ba", "#e671a0", "#b53087", "#530c56"], _ = [
  "#f6f0f0",
  "#f5dedf",
  "#f0b7ba",
  "#e671a0",
  "#b53087",
  "#530c56"
];
export {
  P as DEMOGRAPHICS_PINK_PURPLE_4,
  f as DEMOGRAPHICS_PINK_PURPLE_5,
  _ as DEMOGRAPHICS_PINK_PURPLE_6
};
//# sourceMappingURL=index.es5602.js.map
